import $ from "jquery";

window.addEventListener('load', function () {
    if(document.querySelector('.hamburger')) {
        document.querySelector('.hamburger').addEventListener('click', function() {
            document.querySelector('body').classList.add('nav-is-toggled')
            document.querySelector("body").addEventListener("click", () => {
                if(event.target === document.querySelector("body")) {
                    document.querySelector('body').classList.remove('nav-is-toggled')
                }
            } )
        })
    }

    if(document.querySelector('.close')) {
        document.querySelector('.close').addEventListener("click", e =>{
            document.querySelector('body').classList.remove('nav-is-toggled')
        })
    }

    //Submenu Visite virtuelle
        const $body = document.querySelector("body");
        const $subNavVV = document.querySelector("ul.display--submenu--vv");
        const $displayVV = document.querySelector(".subnav--vv");
        const $btnCloseMenu = document.querySelector(".nav-drill .close")

        if($displayVV) {
            $displayVV.addEventListener("click", () => {
                $displayVV.classList.add("active--color")
                $subNavVV.style.display = "flex"
                $body.append($subNavVV);
            })


        if($btnCloseMenu) {
            $btnCloseMenu.addEventListener("click", () => {
                $displayVV.classList.remove("active--color")
                $subNavVV.style.display = "none"
            })
        }
    }
});
